// Comprehensive i18n Dictionary & Multilingual Localization Engine (UA / EN / DE / FR / PL / IT / ES / PT / SV)

export type Language = 'uk' | 'en' | 'pl' | 'fr' | 'de' | 'it' | 'es' | 'pt' | 'sv';
export type Jurisdiction = 'UA' | 'PL' | 'EU' | 'US' | 'FR' | 'DE' | 'IT' | 'ES' | 'PT' | 'SE';

export const UI_TRANSLATIONS = {
  uk: {
    home: 'На головну',
    back: 'Назад',
    newRequest: 'НОВИЙ_ЗАПИТ',
    search: 'Пошук',
    allCategories: 'Всі категорії',
    launch: 'ЗАПУСТИТИ',
    pricing: 'Тарифи (€/₴)',
    balance: 'Ваш баланс',
    topUp: 'Поповнити баланс',
    logout: 'ВИХІД',
    startOver: 'Почати заново',
    searchFailure: 'Збій координатора пошуку',
    settings: 'Налаштування',
    freeTrialHint: 'Ви використовуєте 1 безкоштовний тестовий запит для цього агента. Наступні запити будуть платними.',
    buySubscription: 'Придбати підписку',
    openHub: 'Відкрити Центр',
    enterpriseTwin: 'Особистий кабінет компанії',
    knowledgeBase: 'База знань підприємства',
    teamRbac: 'Співробітники & Ролі (RBAC)',
    calendarTodo: 'Календар Звітів & To-Do',
    allAgentsCount: 'активних інструментів',
    centerTitle: 'Операційний Центр',
    centers: {
      business: 'Центр Бізнесу & Права',
      tax: 'Податковий Центр (ПКУ)',
      energy: 'Енергетичний Центр & СЕС',
      construction: 'Будівельний Центр & ДБН',
      agri: 'Аграрний Центр & Земля',
      space: 'Космічний Центр & ДЗЗ',
      science: 'Науковий Центр',
      cyber: 'Кібер Центр & Безпека',
      logistics: 'Логістичний Центр',
      office: 'Офісний Центр & Таблиці',
      admin: 'Адміністративний Центр',
      us: 'Центр США & Комплаєнс (US Code)',
      france: 'Французький Центр & Регламенти (FR)',
      germany: 'Німецький Центр & Стандарти (DE / DACH)',
      eu: 'Європейський Центр & Єдиний Ринок ЄС'
    }
  },
  en: {
    home: 'Home',
    back: 'Back',
    newRequest: 'NEW_REQUEST',
    search: 'Search',
    allCategories: 'All Categories',
    launch: 'LAUNCH',
    pricing: 'Pricing (€/$)',
    balance: 'Your balance',
    topUp: 'Top Up Balance',
    logout: 'LOGOUT',
    startOver: 'Start Over',
    searchFailure: 'Search Coordinator Failure',
    settings: 'Settings',
    freeTrialHint: 'You are using 1 free trial request for this agent. Subsequent requests will be paid.',
    buySubscription: 'Buy Subscription',
    openHub: 'Open Hub',
    enterpriseTwin: 'Enterprise Workspace',
    knowledgeBase: 'Enterprise Knowledge Base',
    teamRbac: 'Team & Roles (RBAC)',
    calendarTodo: 'Compliance Calendar & To-Do',
    allAgentsCount: 'active tools',
    centerTitle: 'Operational Center',
    centers: {
      business: 'Business & Legal Center',
      tax: 'Tax & Revenue Center',
      energy: 'Energy & Solar Center',
      construction: 'Construction & Building Center',
      agri: 'Agri & Land Center',
      space: 'Space & Satellite Center',
      science: 'Science & Research Center',
      cyber: 'Cybersecurity & Defense Center',
      logistics: 'Logistics & Supply Chain Center',
      office: 'Office & Spreadsheets Center',
      admin: 'Administrative Center',
      us: 'US Enterprise & Compliance Center',
      france: 'France Enterprise & Regulatory Center',
      germany: 'Germany & DACH Enterprise Center (DE)',
      eu: 'EU Enterprise & Single Market Center'
    }
  },
  pl: {
    home: 'Strona główna',
    back: 'Wróć',
    newRequest: 'NOWE_ZAPYTANIE',
    search: 'Szukaj',
    allCategories: 'Wszystkie kategorie',
    launch: 'URUCHOM',
    pricing: 'Cennik (€/zł/$)',
    balance: 'Twoje saldo',
    topUp: 'Doładuj konto',
    logout: 'WYLOGUJ',
    startOver: 'Zacznij od nowa',
    searchFailure: 'Błąd koordynatora wyszukiwania',
    settings: 'Ustawienia',
    freeTrialHint: 'Używasz 1 bezpłatnego zapytania testowego dla tego modułu. Następne zapytania będą płatne.',
    buySubscription: 'Kup abonament',
    openHub: 'Otwórz Centrum',
    enterpriseTwin: 'Panel Firmy (Enterprise)',
    knowledgeBase: 'Baza wiedzy przedsiębiorstwa',
    teamRbac: 'Pracownicy & Uprawnienia (RBAC)',
    calendarTodo: 'Kalendarz Raportów & To-Do',
    allAgentsCount: 'aktywnych modułów',
    centerTitle: 'Centrum Operacyjne',
    centers: {
      business: 'Centrum Biznesu & Prawa',
      tax: 'Centrum Podatkowe (KSeF / CIT / VAT)',
      energy: 'Centrum Energetyki & OZE',
      construction: 'Centrum Budowlane & FIDIC',
      agri: 'Centrum Rolnictwa & Gruntów',
      space: 'Centrum Kosmiczne & Satelitarne',
      science: 'Centrum Nauki & B+R',
      cyber: 'Centrum Cyberbezpieczeństwa',
      logistics: 'Centrum Logistyki & Transportu',
      office: 'Centrum Biurowe & Arkusze Excel',
      admin: 'Centrum Administracyjne',
      us: 'Centrum USA & Compliance (US Law)',
      france: 'Centrum Francuskie & Regulacje',
      germany: 'Centrum Niemcy & Standardy (DE / DACH)',
      eu: 'Centrum Unii Europejskiej & Jednolity Rynek'
    }
  },
  de: {
    home: 'Startseite',
    back: 'Zurück',
    newRequest: 'NEUE_ANFRAGE',
    search: 'Suchen',
    allCategories: 'Alle Kategorien',
    launch: 'STARTEN',
    pricing: 'Preise (€/$)',
    balance: 'Ihr Guthaben',
    topUp: 'Guthaben aufladen',
    logout: 'ABMELDEN',
    startOver: 'Neu beginnen',
    searchFailure: 'Fehler des Suchkoordinators',
    settings: 'Einstellungen',
    freeTrialHint: 'Sie nutzen 1 kostenlose Testanfrage für dieses Modul. Weitere Anfragen werden über Ihr Abonnement abgerechnet.',
    buySubscription: 'Abonnement abschließen',
    openHub: 'Hub öffnen',
    enterpriseTwin: 'Unternehmensbereich',
    knowledgeBase: 'Unternehmens-Wissensdatenbank',
    teamRbac: 'Mitarbeiter & Rollen (RBAC)',
    calendarTodo: 'Compliance-Kalender & To-Do',
    allAgentsCount: 'aktive Expertenmodule',
    centerTitle: 'Operationszentrum',
    centers: {
      business: 'Zentrum für Wirtschafts- & Vertragsrecht',
      tax: 'Steuerzentrum & XRechnung / GoBD',
      energy: 'Energie- & Solarzentrum',
      construction: 'Bauzentrum, VOB/B & HOAI',
      agri: 'Agrar- & Bodenzentrum',
      space: 'Raumfahrt & Satellitenfernerkundung',
      science: 'Forschungs- & Wissenschaftszentrum',
      cyber: 'Cybersicherheit & DSGVO',
      logistics: 'Logistik- & Zollzentrum',
      office: 'Büroanwendungen & Excel',
      admin: 'Verwaltungszentrum',
      us: 'US Enterprise & Compliance Center',
      france: 'Frankreich Enterprise & Compliance Hub',
      germany: 'Deutschland & DACH Operationszentrum',
      eu: 'EU Enterprise & Binnenmarktzentrum'
    }
  },
  fr: {
    home: 'Accueil',
    back: 'Retour',
    newRequest: 'NOUVELLE_REQUÊTE',
    search: 'Rechercher',
    allCategories: 'Toutes les catégories',
    launch: 'LANCER',
    pricing: 'Tarifs (€/$)',
    balance: 'Votre solde',
    topUp: 'Recharger le solde',
    logout: 'DÉCONNEXION',
    startOver: 'Recommencer',
    searchFailure: 'Échec du coordinateur de recherche',
    settings: 'Paramètres',
    freeTrialHint: 'Vous disposez d\'un essai gratuit pour ce module. Les requêtes suivantes seront décomptées de votre abonnement.',
    buySubscription: 'Souscrire un abonnement',
    openHub: 'Ouvrir le Hub',
    enterpriseTwin: 'Espace Entreprise',
    knowledgeBase: 'Base de connaissances entreprise',
    teamRbac: 'Collaborateurs & Rôles (RBAC)',
    calendarTodo: 'Calendrier de Conformité & To-Do',
    allAgentsCount: 'modules opérationnels',
    centerTitle: 'Centre Opérationnel',
    centers: {
      business: 'Centre Droit des Affaires & Contrats',
      tax: 'Centre Fiscalité & Factur-X',
      energy: 'Centre Énergie & Solaire',
      construction: 'Centre BTP, CCAG & RE2020',
      agri: 'Centre Agroécologie & PAC',
      space: 'Centre Spatial & Télédétection',
      science: 'Centre Recherche & Science',
      cyber: 'Centre Cybersécurité & RGPD',
      logistics: 'Centre Logistique & Douane',
      office: 'Centre Bureautique & Excel',
      admin: 'Centre Administratif',
      us: 'Hub Entreprise USA & Compliance',
      france: 'Hub Entreprise & Conformité France',
      germany: 'Centre Allemagne & Normes DACH (DE)',
      eu: 'Centre Union Européenne & Marché Unique'
    }
  },
  it: {
    home: 'Home',
    back: 'Indietro',
    newRequest: 'NUOVA_RICHIESTA',
    search: 'Cerca',
    allCategories: 'Tutte le categorie',
    launch: 'AVVIA',
    pricing: 'Tariffe (€/$)',
    balance: 'Il tuo saldo',
    topUp: 'Ricarica saldo',
    logout: 'ESCI',
    startOver: 'Ricomincia',
    searchFailure: 'Errore del coordinatore di ricerca',
    settings: 'Impostazioni',
    freeTrialHint: 'Hai a disposizione 1 richiesta di prova gratuita per questo modulo. Le successive saranno scalate dal tuo abbonamento.',
    buySubscription: 'Acquista abbonamento',
    openHub: 'Apri Hub',
    enterpriseTwin: 'Spazio Aziendale',
    knowledgeBase: 'Base di conoscenza aziendale',
    teamRbac: 'Collaboratori & Ruoli (RBAC)',
    calendarTodo: 'Calendario Conformità & To-Do',
    allAgentsCount: 'moduli operativi',
    centerTitle: 'Centro Operativo',
    centers: {
      business: 'Centro Diritto Societario & Contratti',
      tax: 'Centro Fiscale & FatturaPA / SDI',
      energy: 'Centro Energia & Solare',
      construction: 'Centro Edilizia & Codice Appalti',
      agri: 'Centro Agricoltura & Catasto',
      space: 'Centro Spaziale & Telerilevamento',
      science: 'Centro Ricerca & Scienza',
      cyber: 'Centro Sicurezza Informatica & GDPR',
      logistics: 'Centro Logistica & Dogane',
      office: 'Centro Ufficio & Tabelle Excel',
      admin: 'Centro Amministrativo',
      us: 'Hub Aziendale USA & Compliance',
      france: 'Hub Conformità Francia',
      germany: 'Hub Standard Germania (DE / DACH)',
      eu: 'Centro Unione Europea & Mercato Unico'
    }
  },
  es: {
    home: 'Inicio',
    back: 'Volver',
    newRequest: 'NUEVA_SOLICITUD',
    search: 'Buscar',
    allCategories: 'Todas las categorías',
    launch: 'INICIAR',
    pricing: 'Precios (€/$)',
    balance: 'Tu saldo',
    topUp: 'Recargar saldo',
    logout: 'CERRAR SESIÓN',
    startOver: 'Empezar de nuevo',
    searchFailure: 'Error del coordinador de búsqueda',
    settings: 'Configuración',
    freeTrialHint: 'Dispones de 1 solicitud de prueba gratuita para este módulo. Las siguientes se descontarán de tu suscripción.',
    buySubscription: 'Comprar suscripción',
    openHub: 'Abrir Hub',
    enterpriseTwin: 'Espacio de Empresa',
    knowledgeBase: 'Base de conocimiento empresarial',
    teamRbac: 'Equipo & Roles (RBAC)',
    calendarTodo: 'Calendario de Cumplimiento & Tareas',
    allAgentsCount: 'módulos activos',
    centerTitle: 'Centro Operativo',
    centers: {
      business: 'Centro Legal & Mercantil',
      tax: 'Centro Fiscal & FacturaE / AEAT',
      energy: 'Centro Energía & Solar',
      construction: 'Centro Construcción & LCSP',
      agri: 'Centro Agrícola & Catastro',
      space: 'Centro Espacial & Teledetección',
      science: 'Centro Investigación & Ciencia',
      cyber: 'Centro Ciberseguridad & RGPD',
      logistics: 'Centro Logística & Aduanas',
      office: 'Centro Ofimática & Tablas Excel',
      admin: 'Centro Administrativo',
      us: 'Hub Empresa EE. UU. & Compliance',
      france: 'Hub Conformidad Francia',
      germany: 'Hub Estándares Alemania (DE / DACH)',
      eu: 'Centro Unión Europea & Mercado Único'
    }
  },
  pt: {
    home: 'Início',
    back: 'Voltar',
    newRequest: 'NOVO_PEDIDO',
    search: 'Pesquisar',
    allCategories: 'Todas as categorias',
    launch: 'INICIAR',
    pricing: 'Preços (€/$)',
    balance: 'O seu saldo',
    topUp: 'Carregar saldo',
    logout: 'SAIR',
    startOver: 'Recomeçar',
    searchFailure: 'Falha do coordenador de pesquisa',
    settings: 'Definições',
    freeTrialHint: 'Tem 1 pedido de teste gratuito para este módulo. Os pedidos seguintes serão debitados da sua subscrição.',
    buySubscription: 'Subscrever plano',
    openHub: 'Abrir Hub',
    enterpriseTwin: 'Espaço Empresarial',
    knowledgeBase: 'Base de conhecimento da empresa',
    teamRbac: 'Equipa & Funções (RBAC)',
    calendarTodo: 'Calendário de Conformidade & Tarefas',
    allAgentsCount: 'módulos operacionais',
    centerTitle: 'Centro Operacional',
    centers: {
      business: 'Centro Jurídico & Comercial',
      tax: 'Centro Fiscal & SAF-T / AT',
      energy: 'Centro Energia & Solar',
      construction: 'Centro Construção & Obras Públicas',
      agri: 'Centro Agrícola & Cadastro',
      space: 'Centro Espacial & Teledeteção',
      science: 'Centro Investigação & Ciência',
      cyber: 'Centro Cibersegurança & RGPD',
      logistics: 'Centro Logística & Alfândegas',
      office: 'Centro Escritório & Folhas Excel',
      admin: 'Centro Administrativo',
      us: 'Hub Empresarial EUA & Compliance',
      france: 'Hub Conformidade França',
      germany: 'Hub Padrões Alemanha (DE / DACH)',
      eu: 'Centro União Europeia & Mercado Único'
    }
  },
  sv: {
    home: 'Hem',
    back: 'Tillbaka',
    newRequest: 'NY_FÖRFRÅGAN',
    search: 'Sök',
    allCategories: 'Alla kategorier',
    launch: 'STARTA',
    pricing: 'Priser (kr/€/$)',
    balance: 'Ditt saldo',
    topUp: 'Fyll på saldo',
    logout: 'LOGGA UT',
    startOver: 'Börja om',
    searchFailure: 'Sökkoordinatorfel',
    settings: 'Inställningar',
    freeTrialHint: 'Du har 1 gratis testförfrågan för denna modul. Efterföljande förfrågningar debiteras via ditt abonnemang.',
    buySubscription: 'Köp abonnemang',
    openHub: 'Öppna Hub',
    enterpriseTwin: 'Företagsyta',
    knowledgeBase: 'Företagets kunskapsbas',
    teamRbac: 'Medarbetare & Roller (RBAC)',
    calendarTodo: 'Efterlevnadskalender & Uppgifter',
    allAgentsCount: 'aktiva moduler',
    centerTitle: 'Operativt Center',
    centers: {
      business: 'Affärsjuridik & Avtalsrätt',
      tax: 'Skattecenter & Moms / PEPPOL',
      energy: 'Energi- & Solcellscenter',
      construction: 'Byggcenter & AB 04 / ABT 06',
      agri: 'Lantbruks- & Fastighetscenter',
      space: 'Rymd- & Fjärranalyscenter',
      science: 'Forskning & Vetenskapscenter',
      cyber: 'Cybersäkerhet & GDPR',
      logistics: 'Logistik- & Tullcenter',
      office: 'Kontorsverktyg & Kalkylblad',
      admin: 'Administrativt Center',
      us: 'USA Företags- & Efterlevnadscenter',
      france: 'Frankrike Efterlevnadscenter',
      germany: 'Tyskland & DACH Center (DE)',
      eu: 'EU Företags- & Inremarknadscenter'
    }
  }
};

// Polish translation mappings for specialized agents
const PL_AGENT_TRANSLATIONS: Record<string, { name: string; desc: string; category: string }> = {
  'sales-product-optimizer': {
    name: 'Optymalizator Sprzedaży & Produktu (B2B/E-com)',
    desc: 'Automatyczna analiza lejka sprzedażowego, optymalizacja marży, korelacja cenowa i generowanie strategii sprzedaży z eksportem do Word/Excel.',
    category: 'BIZNES & ZARZĄDZANIE'
  },
  'market-intelligence': {
    name: 'Analityk Rynkowy & Wywiad Gospodarczy',
    desc: 'Głęboka analiza rynku, badanie konkurencji, analiza trendów branżowych CEE i prognozowanie popytu z syntezą raportów rynkowych.',
    category: 'BIZNES & ZARZĄDZANIE'
  },
  'contract-auditor': {
    name: 'Audytor Umów & Ryzyk Prawnych (Kodeks Cywilny)',
    desc: 'Automatyczny audyt umów handlowych, NDA, SLA i kontraktów międzynarodowych. Wykrywanie klauzul abuzywnych, kar umownych i ryzyk prawnych.',
    category: 'PRAWO & JURYSPRUDENCJA'
  },
  'commercial-contract-auditor': {
    name: 'Audytor Umów Handlowych & Dostaw B2B',
    desc: 'Sprawdzanie umów dostawy, dystrybucji, najmu komercyjnego i świadczenia usług pod kątem zgodności z prawem handlowym i podatkowym.',
    category: 'PRAWO & JURYSPRUDENCJA'
  },
  'legal-doc-creator': {
    name: 'Konstruktor Dokumentów Prawnych & Pism',
    desc: 'Generowanie pozwów, wezwań do zapłaty, reklamacji, aneksów i projektów umów w języku polskim i angielskim zgodnie ze standardami prawnymi.',
    category: 'PRAWO & JURYSPRUDENCJA'
  },
  'legislation-tracker': {
    name: 'Inteligentny Monitor Zmian Prawnych & Podatkowych',
    desc: 'Całodobowy monitoring zmian w przepisach prawnych, podatkach (KSeF, VAT, CIT), zamówieniach publicznych i orzecznictwie sądowym.',
    category: 'PRAWO & JURYSPRUDENCJA'
  },
  'court-compliance': {
    name: 'Analityk Ryzyka Procesowego & Sądowego',
    desc: 'Ocena szans procesowych, analiza orzecznictwa sądów powszechnych i Sądu Najwyższego oraz przygotowanie strategii obrony.',
    category: 'BEZPIECZEŃSTWO & COMPLIANCE'
  },
  'aml-auditor': {
    name: 'Audytor AML & Weryfikacji Sankcyjnej (KYC)',
    desc: 'Weryfikacja kontrahentów na międzynarodowych listach sankcyjnych (UE, OFAC, ONZ), badanie PEP oraz compliance przeciwdziałania praniu pieniędzy.',
    category: 'BEZPIECZEŃSTWO & COMPLIANCE'
  },
  'tender-analyst': {
    name: 'Analityk Przetargów Publicznych (TED & Zamówienia)',
    desc: 'Kompleksowa analiza specyfikacji warunków zamówienia (SWZ/SIWZ), wykrywanie warunków dyskryminacyjnych i generowanie ofert przetargowych.',
    category: 'ZAMÓWIENIA PUBLICZNE'
  },
  'fop-tax-declarator': {
    name: 'Doradca Podatkowy JDG & Ryczałt (PIT/VAT)',
    desc: 'Kalkulacja podatków dla jednoosobowej działalności gospodarczej, wybór formy opodatkowania (liniowy, skala, ryczałt) i składki ZUS.',
    category: 'PODATKI & KSIĘGOWOŚĆ'
  },
  'corporate-income-tax-declarator': {
    name: 'Doradca Podatku Dochodowego CIT (Spółki)',
    desc: 'Audyt deklaracji CIT-8, optymalizacja kosztów uzyskania przychodów, ulgi podatkowe (B+R, IP Box) i rozliczanie estońskiego CIT.',
    category: 'PODATKI & KSIĘGOWOŚĆ'
  },
  'vat-tax-declarator': {
    name: 'Konsultant Podatku VAT & Systemu KSeF',
    desc: 'Weryfikacja plików JPK_V7, obowiązkowy Krajowy System e-Faktur (KSeF), transakcje wewnątrzwspólnotowe WNT/WDT oraz mechanizm Split Payment.',
    category: 'PODATKI & KSIĘGOWOŚĆ'
  },
  'payroll-tax-declarator': {
    name: 'Kalkulator Płac & Składek ZUS (Kadry)',
    desc: 'Naliczanie wynagrodzeń (Umowa o pracę, Zlecenie, Dzieło, B2B), kalkulacja zaliczek PIT-4R oraz składek ZUS i PPK.',
    category: 'PODATKI & KSIĘGOWOŚĆ'
  },
  'koshtorisnyk': {
    name: 'Inżynier Kosztorysów & Standardów Budowlanych',
    desc: 'Weryfikacja przedmiarów robót, norm kosztorysowych, stawek materiałowych i kalkulacja kosztorysów inwestorskich oraz powykonawczych.',
    category: 'BUDOWNICTWO & INŻYNIERIA'
  },
  'construction-acts-auditor-kb2-kb3': {
    name: 'Audytor Protokołów Odbioru Robót Budowlanych, Obmiarów i Kosztorysów',
    desc: 'Kompleksowa weryfikacja protokołów odbioru robót budowlanych, obmiarów, kosztorysów powykonawczych i certyfikatów FIDIC IPC z wykrywaniem zawyżeń cen.',
    category: 'BUDOWNICTWO & INŻYNIERIA'
  },
  'construction-estimate-parser-avk': {
    name: 'Audytor Plików Kosztorysowych Norma PRO / BDK / XML',
    desc: 'Import i audyt plików z programów kosztorysowych (Norma PRO, Zuzia, AVK-5, XML), weryfikacja stawek RMS i narzutów Kp/Z.',
    category: 'BUDOWNICTWO & INŻYNIERIA'
  },
  'construction-pto-work-log-auditor': {
    name: 'Audytor Dziennika Budowy i Dokumentacji Powykonawczej',
    desc: 'Weryfikacja wpisów w Dzienniku Budowy, protokołów odbioru robót zanikających, badań laboratoryjnych betonu i atestów materiałowych.',
    category: 'BUDOWNICTWO & INŻYNIERIA'
  },
  'construction-bim-ifc-boq-extractor': {
    name: 'Analityk Modeli BIM IFC & Przedmiarów Robót',
    desc: 'Automatyczny przedmiar i ekstrakcja kubatur materiałów (beton, stal, instalacje) z modeli BIM IFC i porównanie z kosztorysami ofertowymi.',
    category: 'BUDOWNICTWO & INŻYNIERIA'
  }
};

export const CATEGORY_MAP: Record<string, { uk: string; en: string; pl: string; de: string; fr: string; it: string; es: string; pt: string; sv: string }> = {
  "ALL": { 
    uk: "Всі категорії", 
    en: "All Categories", 
    pl: "Wszystkie kategorie", 
    de: "Alle Kategorien", 
    fr: "Toutes les catégories",
    it: "Tutte le categorie",
    es: "Todas las categorías",
    pt: "Todas as categorias",
    sv: "Alla kategorier"
  },
  "БІЗНЕС, ЮРИСПРУДЕНЦІЯ & КОНСАЛТИНГ": { 
    uk: "БІЗНЕС, ЮРИСПРУДЕНЦІЯ & КОНСАЛТИНГ", 
    en: "BUSINESS, LEGAL & CONSULTING", 
    pl: "BIZNES, PRAWO & DORADZTWO", 
    de: "WIRTSCHAFT, RECHT & BERATUNG", 
    fr: "AFFAIRES, DROIT & CONSEIL",
    it: "AFFARI, DIRITTO & CONSULENZA",
    es: "NEGOCIOS, DERECHO & CONSULTORÍA",
    pt: "NEGÓCIOS, DIREITO & CONSULTORIA",
    sv: "AFFÄRER, JURIDIK & KONSULTATION"
  },
  "УПРАВЛІННЯ & ПЛАНУВАННЯ": { 
    uk: "УПРАВЛІННЯ & ПЛАНУВАННЯ", 
    en: "MANAGEMENT & PLANNING", 
    pl: "ZARZĄDZANIE & PLANOWANIE", 
    de: "MANAGEMENT & PLANUNG", 
    fr: "MANAGEMENT & PLANIFICATION",
    it: "GESTIONE & PIANIFICAZIONE",
    es: "GESTIÓN & PLANIFICACIÓN",
    pt: "GESTÃO & PLANEAMENTO",
    sv: "LEDNING & PLANERING"
  },
  "ОФІСНІ ДОДАТКИ & ТАБЛИЦІ": { 
    uk: "ОФІСНІ ДОДАТКИ & ТАБЛИЦІ", 
    en: "OFFICE TOOLS & SPREADSHEETS", 
    pl: "APLIKACJE BIUROWE & TABELE", 
    de: "BÜROANWENDUNGEN & TABELLEN", 
    fr: "BUREAUTIQUE & TABLEURS",
    it: "STRUMENTI UFFICIO & FOGLI DI CALCOLO",
    es: "OFIMÁTICA & HOJAS DE CÁLCULO",
    pt: "ESCRITÓRIO & FOLHAS DE CÁLCULO",
    sv: "KONTORSVERKTYG & KALKYLBLAD"
  },
  "АНАЛІТИКА & ПОШУК": { 
    uk: "АНАЛІТИКА & ПОШУК", 
    en: "ANALYTICS & SEARCH", 
    pl: "ANALITYKA & WYSZUKIWANIE", 
    de: "ANALYTIK & SUCHE", 
    fr: "ANALYTIQUE & RECHERCHE",
    it: "ANALITICA & RICERCA",
    es: "ANALÍTICA & BÚSQUEDA",
    pt: "ANALÍTICA & PESQUISA",
    sv: "ANALYS & SÖKNING"
  },
  "МОНІТОРИНГ & НОВИНИ": { 
    uk: "МОНІТОРИНГ & НОВИНИ", 
    en: "MONITORING & NEWS", 
    pl: "MONITORING & WIADOMOŚCI", 
    de: "MONITORING & NACHRICHTEN", 
    fr: "VEILLE & ACTUALITÉS",
    it: "MONITORAGGIO & NOTIZIE",
    es: "MONITORIZACIÓN & NOTICIAS",
    pt: "MONITORIZAÇÃO & NOTÍCIAS",
    sv: "BEVAKNING & NYHETER"
  },
  "БУДІВНИЦТВО & ДБН": { 
    uk: "БУДІВНИЦТВО & ДБН", 
    en: "CONSTRUCTION & DBN", 
    pl: "BUDOWNICTWO & NORMY", 
    de: "BAUWESEN, VOB & NORMEN", 
    fr: "BTP & NORMES DE CONSTRUCTION",
    it: "EDILIZIA & NORME TECNICHE",
    es: "CONSTRUCCIÓN & NORMAS TÉCNICAS",
    pt: "CONSTRUÇÃO & NORMAS TÉCNICAS",
    sv: "BYGG & NORMER"
  },
  "РЕДАКТУВАННЯ & ПРАВОПИС": { 
    uk: "РЕДАКТУВАННЯ & ПРАВОПИС", 
    en: "EDITING & GRAMMAR", 
    pl: "REDAKCJA & POPRAWNOŚĆ", 
    de: "REDAKTION & RECHTSCHREIBUNG", 
    fr: "RÉDACTION & ORTHOGRAPHE",
    it: "REDAZIONE & CORREZIONE",
    es: "REDACCIÓN & CORRECCIÓN",
    pt: "REDAÇÃO & CORREÇÃO",
    sv: "REDAKTERING & SPRÅKGRANSKNING"
  },
  "ДОКУМЕНТООБІГ & ДІЛОВОДСТВО": { 
    uk: "ДОКУМЕНТООБІГ & ДІЛОВОДСТВО", 
    en: "DOCUMENT WORKFLOW", 
    pl: "OBIEG DOKUMENTÓW", 
    de: "DOKUMENTENMANAGEMENT", 
    fr: "GESTION DOCUMENTAIRE",
    it: "FLUSSO DOCUMENTALE",
    es: "GESTIÓN DOCUMENTAL",
    pt: "FLUXO DE DOCUMENTOS",
    sv: "DOKUMENTHANTERING"
  },
  "ВІДЕО & МЕДІА": { 
    uk: "ВІДЕО & МЕДІА", 
    en: "VIDEO & MEDIA", 
    pl: "WIDEO & MEDIA", 
    de: "VIDEO & MEDIEN", 
    fr: "VIDÉO & MÉDIAS",
    it: "VIDEO & MEDIA",
    es: "VÍDEO & MEDIOS",
    pt: "VÍDEO & MULTIMÉDIA",
    sv: "VIDEO & MEDIA"
  },
  "ЮРИСПРУДЕНЦІЯ & ПРАВО": { 
    uk: "ЮРИСПРУДЕНЦІЯ & ПРАВО", 
    en: "LAW & JURISPRUDENCE", 
    pl: "PRAWO & JURYSPRUDENCJA", 
    de: "RECHT & JURISPRUDENZ", 
    fr: "DROIT & JURISPRUDENCE",
    it: "DIRITTO & GIURISPRUDENZA",
    es: "DERECHO & JURISPRUDENCIA",
    pt: "DIREITO & JURISPRUDÊNCIA",
    sv: "JURIDIK & LAG"
  },
  "БЕЗПЕКА & КОМПЛАЄНС": { 
    uk: "БЕЗПЕКА & КОМПЛАЄНС", 
    en: "SECURITY & COMPLIANCE", 
    pl: "BEZPIECZEŃSTWO & COMPLIANCE", 
    de: "SICHERHEIT & COMPLIANCE", 
    fr: "SÉCURITÉ & CONFORMITÉ",
    it: "SICUREZZA & CONFORMITÀ",
    es: "SEGURIDAD & CUMPLIMIENTO",
    pt: "SEGURANÇA & CONFORMIDADE",
    sv: "SÄKERHET & EFTERLEVNAD"
  },
  "ЗАКУПІВЛІ & PROZORRO": { 
    uk: "ЗАКУПІВЛІ & PROZORRO", 
    en: "PROCUREMENT & TENDERS", 
    pl: "ZAMÓWIENIA PUBLICZNE & PRZETARGI", 
    de: "ÖFFENTLICHE VERGABE & AUSSCHREIBUNGEN", 
    fr: "MARCHÉS PUBLICS & APPELS D'OFFRES",
    it: "APPALTI PUBBLICI & GARE",
    es: "CONTRATACIÓN PÚBLICA & LICITACIONES",
    pt: "CONTRATAÇÃO PÚBLICA & CONCURSOS",
    sv: "UPPHANDLING & ANBUD"
  },
  "ФІНАНСИ & БУХГАЛТЕРІЯ": { 
    uk: "ФІНАНСИ & БУХГАЛТЕРІЯ", 
    en: "FINANCE & ACCOUNTING", 
    pl: "FINANSE & KSIĘGOWOŚĆ", 
    de: "FINANZEN & BUCHHALTUNG", 
    fr: "FINANCES & COMPTABILITÉ",
    it: "FINANZA & CONTABILITÀ",
    es: "FINANZAS & CONTABILIDAD",
    pt: "FINANÇAS & CONTABILIDADE",
    sv: "FINANS & BOKFÖRING"
  },
  "АГРОБІЗНЕС & ЗЕМЛЯ": { 
    uk: "АГРОБІЗНЕС & ЗЕМЛЯ", 
    en: "AGRIBUSINESS & LAND", 
    pl: "AGROBIZNES & GRUNTY", 
    de: "AGRARWIRTSCHAFT & BODEN", 
    fr: "AGRO-INDUSTRIE & FONCIER",
    it: "AGRIBUSINESS & TERRENI",
    es: "AGRONEGOCIO & TIERRAS",
    pt: "AGRONEGÓCIO & TERRENOS",
    sv: "LANTBRUK & MARK"
  },
  "ДЕРЖАВНІ ЗАКУПІВЛІ & БЮДЖЕТ": { 
    uk: "ДЕРЖАВНІ ЗАКУПІВЛІ & БЮДЖЕТ", 
    en: "PUBLIC PROCUREMENT & BUDGET", 
    pl: "ZAMÓWIENIA PUBLICZNE & BUDŻET", 
    de: "ÖFFENTLICHES BUDGET & BESCHAFFUNG", 
    fr: "COMMANDE PUBLIQUE & BUDGET",
    it: "APPALTI PUBBLICI & BILANCIO",
    es: "COMPRAS PÚBLICAS & PRESUPUESTO",
    pt: "COMPRAS PÚBLICAS & ORÇAMENTO",
    sv: "OFFENTLIG UPPHANDLING & BUDGET"
  },
  "ЕКОЛОГІЯ & ESG": { 
    uk: "ЕКОЛОГІЯ & ESG", 
    en: "ECOLOGY & ESG", 
    pl: "EKOLOGIA & ESG", 
    de: "ÖKOLOGIE & ESG", 
    fr: "ÉCOLOGIE & ESG",
    it: "ECOLOGIA & ESG",
    es: "ECOLOGÍA & ESG",
    pt: "ECOLOGIA & ESG",
    sv: "EKOLOGI & ESG"
  },
  "АДМІНІСТРУВАННЯ & OSINT": { 
    uk: "АДМІНІСТРУВАННЯ & OSINT", 
    en: "ADMINISTRATION & OSINT", 
    pl: "ADMINISTRACJA & OSINT", 
    de: "VERWALTUNG & OSINT", 
    fr: "ADMINISTRATION & OSINT",
    it: "AMMINISTRAZIONE & OSINT",
    es: "ADMINISTRACIÓN & OSINT",
    pt: "ADMINISTRAÇÃO & OSINT",
    sv: "ADMINISTRATION & OSINT"
  },
  "НАРОДНА МЕДИЦИНА & ТРАДИЦІЇ (ADMIN)": { 
    uk: "НАРОДНА МЕДИЦИНА & ТРАДИЦІЇ (ADMIN)", 
    en: "HERBAL & TRADITIONAL MEDICINE", 
    pl: "MEDYCYNA NATURALNA & ZIOŁA", 
    de: "NATURHEILKUNDE & TRADITIONEN", 
    fr: "PHYTOTHÉRAPIE & TRADITIONS",
    it: "MEDICINA NATURALE & TRADIZIONI",
    es: "MEDICINA NATURAL & TRADICIONES",
    pt: "MEDICINA NATURAL & TRADIÇÕES",
    sv: "NATURLIG MEDICIN & TRADITIONER"
  },
  "ПЕРЕКЛАД & ДОКУМЕНТООБІГ": { 
    uk: "ПЕРЕКЛАД & ДОКУМЕНТООБІГ", 
    en: "TRANSLATION & WORKFLOW", 
    pl: "TŁUMACZENIA & DOKUMENTY", 
    de: "ÜBERSETZUNG & DOKUMENTE", 
    fr: "TRADUCTION & GESTION DOC",
    it: "TRADUZIONE & GESTIONE DOCUMENTI",
    es: "TRADUCCIÓN & DOCUMENTOS",
    pt: "TRADUÇÃO & DOCUMENTOS",
    sv: "ÖVERSÄTTNING & DOKUMENT"
  },
  "ОЦІНКА МАЙНА & НЕРУХОМОСТІ": { 
    uk: "ОЦІНКА МАЙНА & НЕРУХОМОСТІ", 
    en: "PROPERTY & REAL ESTATE VALUATION", 
    pl: "WYCENA MAJĄTKU & NIERUCHOMOŚCI", 
    de: "IMMOBILIEN- & VERMÖGENSBEWERTUNG", 
    fr: "ÉVALUATION IMMOBILIÈRE & PATRIMOINE",
    it: "VALUTAZIONE IMMOBILIARE & PATRIMONIALE",
    es: "VALORACIÓN INMOBILIARIA & PATRIMONIO",
    pt: "AVALIAÇÃO IMOBILIÁRIA & PATRIMÓNIO",
    sv: "FASTIGHETS- & EGENDOMSVÄRDERING"
  },
  "ЮРИСПРУДЕНЦІЯ & АУДИТ": { 
    uk: "ЮРИСПРУДЕНЦІЯ & АУДИТ", 
    en: "LEGAL & AUDIT", 
    pl: "PRAWO & AUDYT", 
    de: "RECHT & AUDIT", 
    fr: "DROIT & AUDIT",
    it: "DIRITTO & REVISIONE",
    es: "DERECHO & AUDITORÍA",
    pt: "DIREITO & AUDITORIA",
    sv: "JURIDIK & REVISION"
  },
  "ЕКОЛОГІЯ & ДЗЗ": { 
    uk: "ЕКОЛОГІЯ & ДЗЗ", 
    en: "ECOLOGY & REMOTE SENSING", 
    pl: "EKOLOGIA & TELEDETEKCJA", 
    de: "ÖKOLOGIE & FERNERKUNDUNG", 
    fr: "ÉCOLOGIE & TÉLÉDÉTECTION",
    it: "ECOLOGIA & TELERILEVAMENTO",
    es: "ECOLOGÍA & TELEDETECCIÓN",
    pt: "ECOLOGIA & TELEDETEÇÃO",
    sv: "EKOLOGI & FJÄRRANALYS"
  },
  "КОСМОС & ДЗЗ": { 
    uk: "КОСМОС & ДЗЗ", 
    en: "SPACE & REMOTE SENSING (GEOINT)", 
    pl: "KOSMOS & TELEDETEKCJA (GEOINT)", 
    de: "RAUMFAHRT & FERNERKUNDUNG (GEOINT)", 
    fr: "ESPACE & TÉLÉDÉTECTION (GEOINT)",
    it: "SPAZIO & TELERILEVAMENTO (GEOINT)",
    es: "ESPACIO & TELEDETECCIÓN (GEOINT)",
    pt: "ESPAÇO & TELEDETEÇÃO (GEOINT)",
    sv: "RYMD & FJÄRRANALYS (GEOINT)"
  },
  "ВІЙСЬКОВА РОЗВІДКА & GEOINT": { 
    uk: "ВІЙСЬКОВА РОЗВІДКА & GEOINT", 
    en: "DEFENSE INTEL & GEOINT", 
    pl: "WYWIAD WOJSKOWY & GEOINT", 
    de: "VERTEIDIGUNGSAUFKLÄRUNG & GEOINT", 
    fr: "RENSEIGNEMENT DE DÉFENSE & GEOINT",
    it: "INTELLIGENCE DI DIFESA & GEOINT",
    es: "INTELIGENCIA DE DEFENSA & GEOINT",
    pt: "INTELIGÊNCIA DE DEFESA & GEOINT",
    sv: "FÖRSVARSINTEL & GEOINT"
  },
  "ФАРМАЦЕВТИКА & ОХОРОНА ЗДОРОВ'Я": { 
    uk: "ФАРМАЦЕВТИКА & ОХОРОНА ЗДОРОВ'Я", 
    en: "PHARMACEUTICALS & HEALTHCARE", 
    pl: "FARMACJA & OCHRONA ZDROWIA", 
    de: "PHARMAZIE & GESUNDHEITSWESEN", 
    fr: "PHARMACEUTIQUE & SANTÉ",
    it: "FARMACEUTICA & SANITÀ",
    es: "FARMACÉUTICA & SALUD",
    pt: "FARMACÊUTICA & SAÚDE",
    sv: "LÄKEMEDEL & HÄLSOVÅRD"
  },
  "ЕНЕРГЕТИКА & ВДЕ": { 
    uk: "ЕНЕРГЕТИКА & ВДЕ", 
    en: "ENERGY & RENEWABLES", 
    pl: "ENERGETYKA & OZE", 
    de: "ENERGIE & ERNEUERBARE ENERGIEN", 
    fr: "ÉNERGIE & ENR",
    it: "ENERGIA & RINNOVABILI",
    es: "ENERGÍA & RENOVABLES",
    pt: "ENERGIA & RENOVÁVEIS",
    sv: "ENERGI & FÖRNYBART"
  },
  "КІБЕРБЕЗПЕКА & IT": { 
    uk: "КІБЕРБЕЗПЕКА & IT", 
    en: "CYBERSECURITY & IT", 
    pl: "CYBERBEZPIECZEŃSTWO & IT", 
    de: "CYBERSICHERHEIT & IT", 
    fr: "CYBERSÉCURITÉ & IT",
    it: "SICUREZZA INFORMATICA & IT",
    es: "CIBERSEGURIDAD & IT",
    pt: "CIBERSEGURANÇA & IT",
    sv: "CYBERSÄKERHET & IT"
  },
  "ЛОГІСТИКА & ТРАНСПОРТ": { 
    uk: "ЛОГІСТИКА & ТРАНСПОРТ", 
    en: "LOGISTICS & TRANSPORT", 
    pl: "LOGISTYKA & TRANSPORT", 
    de: "LOGISTIK & TRANSPORT", 
    fr: "LOGISTIQUE & TRANSPORT",
    it: "LOGISTICA & TRASPORTI",
    es: "LOGÍSTICA & TRANSPORTE",
    pt: "LOGÍSTICA & TRANSPORTE",
    sv: "LOGISTIK & TRANSPORT"
  },
  "НАУКА & ДОСЛІДЖЕННЯ": { 
    uk: "НАУКА & ДОСЛІДЖЕННЯ", 
    en: "SCIENCE & RESEARCH", 
    pl: "NAUKA & BADANIA", 
    de: "WISSENSCHAFT & FORSCHUNG", 
    fr: "SCIENCE & RECHERCHE",
    it: "SCIENZA & RICERCA",
    es: "CIENCIA & INVESTIGACIÓN",
    pt: "CIÊNCIA & INVESTIGAÇÃO",
    sv: "VETENSKAP & FORSKNING"
  },
  "ПОДАТКИ, БУХГАЛТЕРІЯ & ФІНАНСИ": { 
    uk: "ПОДАТКИ, БУХГАЛТЕРІЯ & ФІНАНСИ", 
    en: "TAX, ACCOUNTING & FINANCE", 
    pl: "PODATKI, KSIĘGOWOŚĆ & FINANSE", 
    de: "STEUERN, BUCHHALTUNG & FINANZEN", 
    fr: "FISCALITÉ, COMPTABILITÉ & FINANCES",
    it: "FISCO, CONTABILITÀ & FINANZA",
    es: "IMPUESTOS, CONTABILIDAD & FINANZAS",
    pt: "IMPOSTOS, CONTABILIDADE & FINANÇAS",
    sv: "SKATT, BOKFÖRING & FINANS"
  },
  "БУДІВНИЦТВО, ПРОЕКТУВАННЯ & КОШТОРИСИ": { 
    uk: "БУДІВНИЦТВО, ПРОЕКТУВАННЯ & КОШТОРИСИ", 
    en: "CONSTRUCTION, ENGINEERING & ARCHITECTURE", 
    pl: "BUDOWNICTWO, PROJEKTOWANIE & KOSZTORYSY", 
    de: "BAU, INGENIEURWESEN & KOSTENSCHÄTZUNG", 
    fr: "BTP, INGÉNIERIE & DEVIS DE CHANTIER",
    it: "EDILIZIA, INGEGNERIA & PREVENTIVI",
    es: "CONSTRUCCIÓN, INGENIERÍA & PRESUPUESTOS",
    pt: "CONSTRUÇÃO, ENGENHARIA & ORÇAMENTOS",
    sv: "BYGG, INGENJÖRSKONST & KALKYLERING"
  },
  "ТЕНДЕРИ & ДЕРЖЗАКУПІВЛІ": { 
    uk: "ТЕНДЕРИ & ДЕРЖЗАКУПІВЛІ", 
    en: "TENDERS & PUBLIC PROCUREMENT", 
    pl: "PRZETARGI & ZAMÓWIENIA PUBLICZNE", 
    de: "AUSSCHREIBUNGEN & ÖFFENTLICHE VERGABE", 
    fr: "APPELS D'OFFRES & MARCHÉS PUBLICS",
    it: "GARE D'APPALTO & CONTRATTI PUBBLICI",
    es: "LICITACIONES & CONTRATACIÓN PÚBLICA",
    pt: "CONCURSOS & CONTRATAÇÃO PÚBLICA",
    sv: "ANBUD & OFFENTLIG UPPHANDLING"
  },
  "АГРОСЕКТОР, ЗЕМЕЛЬНИЙ БАНК & ЕКОЛОГІЯ": { 
    uk: "АГРОСЕКТОР, ЗЕМЕЛЬНИЙ БАНК & ЕКОЛОГІЯ", 
    en: "AGRIBUSINESS, LAND & ECOLOGY", 
    pl: "ROLNICTWO, GRUNTY & EKOLOGIA", 
    de: "AGRARSEKTOR, BODEN & ÖKOLOGIE", 
    fr: "AGRO-INDUSTRIE, TERRES & ÉCOLOGIE",
    it: "AGRIBUSINESS, TERRENI & ECOLOGIA",
    es: "AGRONEGOCIO, TIERRAS & ECOLOGÍA",
    pt: "AGRONEGÓCIO, TERRENOS & ECOLOGIA",
    sv: "LANTBRUK, MARK & EKOLOGI"
  },
  "КІБЕРБЕЗПЕКА, ІТ & ЗАХИСТ ІНФОРМАЦІЇ": { 
    uk: "КІБЕРБЕЗПЕКА, ІТ & ЗАХИСТ ІНФОРМАЦІЇ", 
    en: "CYBERSECURITY, IT & DATA PRIVACY", 
    pl: "CYBERBEZPIECZEŃSTWO, IT & OCHRONA DANYCH", 
    de: "CYBERSICHERHEIT, IT & DATENSCHUTZ", 
    fr: "CYBERSÉCURITÉ, IT & PROTECTION DES DONNÉES",
    it: "SICUREZZA INFORMATICA, IT & PRIVACY",
    es: "CIBERSEGURIDAD, TI & PRIVACIDAD DE DATOS",
    pt: "CIBERSEGURANÇA, TI & PRIVACIDADE DE DADOS",
    sv: "CYBERSÄKERHET, IT & DATASKYDD"
  },
  "ХАБ США & КОРПОРАТИВНЕ ПРАВО US": { 
    uk: "ХАБ США & КОРПОРАТИВНЕ ПРАВО US", 
    en: "US HUB & CORPORATE LAW", 
    pl: "CENTRUM USA & PRAWO KORPORACYJNE", 
    de: "US-HUB & GESELLSCHAFTSRECHT", 
    fr: "HUB USA & DROIT DES SOCIÉTÉS",
    it: "HUB USA & DIRITTO SOCIETARIO",
    es: "HUB EE. UU. & DERECHO CORPORATIVO",
    pt: "HUB EUA & DIREITO SOCIETÁRIO",
    sv: "USA-HUB & BOLAGSRÄTT"
  },
  "ХАБ США & ДЕРЖЗАКУПІВЛІ FAR": { 
    uk: "ХАБ США & ДЕРЖЗАКУПІВЛІ FAR", 
    en: "US HUB & GOV PROCUREMENT FAR", 
    pl: "CENTRUM USA & ZAMÓWIENIA FAR", 
    de: "US-HUB & VERGABERECHT FAR", 
    fr: "HUB USA & MARCHÉS PUBLICS FAR",
    it: "HUB USA & APPALTI FEDERALI FAR",
    es: "HUB EE. UU. & LICITACIONES FAR",
    pt: "HUB EUA & CONTRATOS PÚBLICOS FAR",
    sv: "USA-HUB & STATLIG UPPHANDLING FAR"
  },
  "ХАБ США & ПОДАТКИ IRS": { 
    uk: "ХАБ США & ПОДАТКИ IRS", 
    en: "US HUB & IRS TAXES", 
    pl: "CENTRUM USA & PODATKI IRS", 
    de: "US-HUB & IRS-STEUERN", 
    fr: "HUB USA & FISCALITÉ IRS",
    it: "HUB USA & TASSE IRS",
    es: "HUB EE. UU. & IMPUESTOS IRS",
    pt: "HUB EUA & IMPOSTOS IRS",
    sv: "USA-HUB & IRS-SKATTER"
  },
  "ХАБ США & МИТНИЦЯ CBP & САНКЦІЇ": { 
    uk: "ХАБ США & МИТНИЦЯ CBP & САНКЦІЇ", 
    en: "US HUB & CUSTOMS CBP & SANCTIONS", 
    pl: "CENTRUM USA & CŁO CBP I SANKCJE", 
    de: "US-HUB & ZOLL CBP & SANKTIONEN", 
    fr: "HUB USA & DOUANES CBP & SANCTIONS",
    it: "HUB USA & DOGANE CBP & SANZIONI",
    es: "HUB EE. UU. & ADUANAS CBP & SANCIONES",
    pt: "HUB EUA & ALFÂNDEGAS CBP & SANÇÕES",
    sv: "USA-HUB & TULL CBP & SANKTIONER"
  },
  "ХАБ США & КОНТРАКТИ B2B": { 
    uk: "ХАБ США & КОНТРАКТИ B2B", 
    en: "US HUB & B2B CONTRACTS", 
    pl: "CENTRUM USA & UMOWY B2B", 
    de: "US-HUB & B2B-VERTRÄGE", 
    fr: "HUB USA & CONTRATS B2B",
    it: "HUB USA & CONTRATTI B2B",
    es: "HUB EE. UU. & CONTRATOS B2B",
    pt: "HUB EUA & CONTRATOS B2B",
    sv: "USA-HUB & B2B-AVTAL"
  },
  "ХАБ США & КІБЕРБЕЗПЕКА ТА FDA": { 
    uk: "ХАБ США & КІБЕРБЕЗПЕКА ТА FDA", 
    en: "US HUB & CYBERSECURITY & FDA", 
    pl: "CENTRUM USA & CYBERBEZPIECZEŃSTWO I FDA", 
    de: "US-HUB & CYBERSICHERHEIT & FDA", 
    fr: "HUB USA & CYBERSÉCURITÉ & FDA",
    it: "HUB USA & SICUREZZA INFORMATICA & FDA",
    es: "HUB EE. UU. & CIBERSEGURIDAD & FDA",
    pt: "HUB EUA & CIBERSEGURANÇA & FDA",
    sv: "USA-HUB & CYBERSÄKERHET & FDA"
  }
};

export function getLocalizedText(key: keyof typeof UI_TRANSLATIONS['uk'], lang: Language): string {
  const dict = UI_TRANSLATIONS[lang] || UI_TRANSLATIONS['uk'];
  return (dict as any)[key] || UI_TRANSLATIONS['uk'][key] || key;
}

export function toSafeString(val: any): string {
  if (typeof val === 'string') return val;
  if (!val) return '';
  if (typeof val === 'object') {
    if (typeof val.description === 'string') return val.description;
    if (typeof val.desc === 'string') return val.desc;
    if (typeof val.name === 'string') return val.name;
    if (typeof val.moduleName === 'string') {
      return (Array.isArray(val.functionality) ? val.functionality.join(' ') : '') || val.moduleName;
    }
    if (Array.isArray(val)) return val.map(toSafeString).join(' ');
    try { return JSON.stringify(val); } catch { return ''; }
  }
  return String(val);
}

export function getLocalizedAgentName(agent: any, lang: Language): string {
  if (!agent) return '';
  let res: any = '';
  if (lang === 'de') {
    res = agent.nameDe || agent.nameEn || agent.nameUk;
  } else if (lang === 'fr') {
    res = agent.nameFr || agent.nameEn || agent.nameUk;
  } else if (lang === 'it') {
    res = agent.nameIt || agent.nameEn || agent.nameUk;
  } else if (lang === 'es') {
    res = agent.nameEs || agent.nameEn || agent.nameUk;
  } else if (lang === 'pt') {
    res = agent.namePt || agent.nameEn || agent.nameUk;
  } else if (lang === 'sv') {
    res = agent.nameSv || agent.nameEn || agent.nameUk;
  } else if (lang === 'pl') {
    res = PL_AGENT_TRANSLATIONS[agent.id]?.name || agent.namePl || agent.nameEn || agent.nameUk;
  } else if (lang === 'en') {
    res = agent.nameEn || agent.nameUk;
  } else {
    res = agent.nameUk || agent.nameEn;
  }
  return toSafeString(res);
}

export function getLocalizedAgentDesc(agent: any, lang: Language): string {
  if (!agent) return '';
  let res: any = '';
  if (lang === 'de') {
    res = agent.descriptionDe || agent.descriptionEn || agent.descriptionUk;
  } else if (lang === 'fr') {
    res = agent.descriptionFr || agent.descriptionEn || agent.descriptionUk;
  } else if (lang === 'it') {
    res = agent.descriptionIt || agent.descriptionEn || agent.descriptionUk;
  } else if (lang === 'es') {
    res = agent.descriptionEs || agent.descriptionEn || agent.descriptionUk;
  } else if (lang === 'pt') {
    res = agent.descriptionPt || agent.descriptionEn || agent.descriptionUk;
  } else if (lang === 'sv') {
    res = agent.descriptionSv || agent.descriptionEn || agent.descriptionUk;
  } else if (lang === 'pl') {
    res = PL_AGENT_TRANSLATIONS[agent.id]?.desc || agent.descriptionPl || agent.descriptionEn || agent.descriptionUk;
  } else if (lang === 'en') {
    res = agent.descriptionEn || agent.descriptionUk;
  } else {
    res = agent.descriptionUk || agent.descriptionEn;
  }
  return toSafeString(res);
}

export function getLocalizedAgentCategory(agent: any, lang: Language): string {
  if (!agent) return '';
  const catKey = agent.categoryUk || agent.category;
  let res: any = '';
  if (CATEGORY_MAP[catKey]) {
    res = (CATEGORY_MAP[catKey] as any)[lang] || CATEGORY_MAP[catKey].en || catKey;
  } else {
    res = agent.categoryEn || agent.categoryUk || catKey || '';
  }
  return toSafeString(res);
}

export function getLocalizedAgentFeatures(agent: any, lang: Language): string[] {
  if (!agent) return [];
  let arr: any[] = [];
  if (lang === 'de' && agent.featuresDe?.length) arr = agent.featuresDe;
  else if (lang === 'fr' && agent.featuresFr?.length) arr = agent.featuresFr;
  else if (lang === 'it' && agent.featuresIt?.length) arr = agent.featuresIt;
  else if (lang === 'es' && agent.featuresEs?.length) arr = agent.featuresEs;
  else if (lang === 'pt' && agent.featuresPt?.length) arr = agent.featuresPt;
  else if (lang === 'sv' && agent.featuresSv?.length) arr = agent.featuresSv;
  else if (lang === 'pl' && agent.featuresPl?.length) arr = agent.featuresPl;
  else if (lang === 'en' && agent.featuresEn?.length) arr = agent.featuresEn;
  else arr = agent.featuresUk || agent.featuresEn || [];

  if (!Array.isArray(arr)) return [];
  return arr.map(toSafeString).filter(Boolean);
}

export type Currency = 'UAH' | 'EUR' | 'PLN' | 'USD' | 'SEK';

export function formatPriceWithCurrency(uahAmount: number, currency: Currency = 'UAH'): string {
  if (!uahAmount && uahAmount !== 0) return '0 грн';
  if (currency === 'SEK') {
    if (uahAmount === 0) return '0 kr';
    if (uahAmount <= 25) return '9 kr';
    if (uahAmount <= 100) return '29 kr';
    if (uahAmount <= 250) return '69 kr';
    if (uahAmount <= 500) return '129 kr';
    if (uahAmount <= 2100) return '499 kr';
    const sek = Math.round(uahAmount / 4);
    return `${sek} kr`;
  }
  if (currency === 'USD') {
    if (uahAmount === 0) return '$0';
    if (uahAmount <= 25) return '$0.99';
    if (uahAmount <= 100) return '$2.99';
    if (uahAmount <= 250) return '$6.99';
    if (uahAmount <= 500) return '$12.99';
    if (uahAmount <= 2100) return '$49.00';
    const usd = Math.round(uahAmount / 42);
    return `$${usd}`;
  }
  if (currency === 'EUR') {
    if (uahAmount === 0) return '€0';
    if (uahAmount <= 25) return '€0.99';
    if (uahAmount <= 100) return '€2.99';
    if (uahAmount <= 250) return '€6.99';
    if (uahAmount <= 500) return '€11.99';
    if (uahAmount <= 2100) return '€49.00';
    const eur = Math.round(uahAmount / 45);
    return `€${eur}`;
  }
  if (currency === 'PLN') {
    if (uahAmount === 0) return '0 zł';
    if (uahAmount <= 25) return '4 zł';
    if (uahAmount <= 100) return '12 zł';
    if (uahAmount <= 250) return '29 zł';
    if (uahAmount <= 500) return '49 zł';
    if (uahAmount <= 2100) return '199 zł';
    const pln = Math.round(uahAmount / 10.5);
    return `${pln} zł`;
  }
  return `${uahAmount} грн`;
}
